<app-offcanvas-sheet
  [visible]="visible"
  [title]="title"
  (closeCanvas)="onClose()"
  (save)="onSave()">

  <!-- Budget Name -->
  <div class="form-group-mobile">
    <label>Budget Name</label>
    <input type="text" class="form-control" [(ngModel)]="formData.budgetName" placeholder="e.g. Monthly Ops Budget" />
  </div>

  <!-- Budget Type -->
  <div class="form-group-mobile">
    <label>Budget Type</label>
    <app-single-select-dropdown
      [options]="budgetTypeOptions"
      placeholder="Select type"
      [selectedValue]="formData.budgetType"
      (selectedValueChange)="onBudgetTypeChange($event)">
    </app-single-select-dropdown>
  </div>

  <!-- Date Range -->
  <div class="form-group-mobile">
    <label>Date Range</label>
    <div class="date-range-grid" [class.single]="formData.budgetType === 'Annually'">

      <app-single-select-dropdown *ngIf="formData.budgetType === 'Monthly'"
        [options]="months"
        placeholder="Month"
        [selectedValue]="selectedMonth"
        (selectedValueChange)="selectedMonth = $event">
      </app-single-select-dropdown>

      <app-single-select-dropdown *ngIf="formData.budgetType === 'Quarterly'"
        [options]="quarters"
        placeholder="Quarter"
        [selectedValue]="selectedQuarter"
        (selectedValueChange)="selectedQuarter = $event">
      </app-single-select-dropdown>

      <app-single-select-dropdown
        [options]="years"
        placeholder="Year"
        [selectedValue]="selectedYear"
        (selectedValueChange)="onYearChange($event)">
      </app-single-select-dropdown>
    </div>
  </div>

  <!-- Description -->
  <div class="form-group-mobile">
    <label>Description</label>
    <textarea class="form-control" rows="2" [(ngModel)]="formData.description" placeholder="Optional description"></textarea>
  </div>

  <!-- Budget Lines -->
  <div class="lines-section">
    <div class="lines-header">
      <span class="lines-title">Budget Lines</span>
      <button class="btn btn-sm btn-outline-primary" type="button" (click)="addLine()">
        <i class="bi bi-plus-lg me-1"></i>Add Line
      </button>
    </div>

    <div *ngIf="lineItems.length === 0" class="lines-empty">
      No budget lines yet. Tap "Add Line" to begin.
    </div>

    <div *ngFor="let line of lineItems; let i = index" class="line-card" #lineCard>
      <div class="line-card-header">
        <span class="line-number">Line {{ i + 1 }}</span>
        <button class="line-delete-btn" type="button" (click)="removeLine(i)" aria-label="Remove line">
          <i class="bi bi-trash"></i>
        </button>
      </div>

      <!-- Planned Amount -->
      <div class="form-group-mobile">
        <label>Planned Amount (R)</label>
        <input type="number" class="form-control" [(ngModel)]="line.budgetAmount" placeholder="0.00" min="0" step="0.01" />
      </div>

      <!-- Period -->
      <div class="form-group-mobile">
        <label>Period</label>
        <app-single-select-dropdown
          [options]="fiscalPeriodOptions"
          placeholder="Select period"
          [selectedValue]="line.fiscalPeriodID !== null ? String(line.fiscalPeriodID) : null"
          (selectedValueChange)="line.fiscalPeriodID = $event ? +$event : null">
        </app-single-select-dropdown>
      </div>

      <!-- Notes -->
      <div class="form-group-mobile">
        <label>Notes</label>
        <input type="text" class="form-control" [(ngModel)]="line.notes" placeholder="Optional notes" />
      </div>
    </div>
  </div>

</app-offcanvas-sheet>
